import React from "react";
import AdminHeader from "../admin/components/layout/navbar/AdminHeader";
import AdminSideBar from "../admin/components/layout/sidebar/AdminSideBar";
import { Outlet } from "react-router-dom";

const AdminLayout = () => {
  return (
    <div>
      <AdminHeader />
      <div className="flex">
        <AdminSideBar />
        <div className="w-full h-[90vh] overflow-x-hidden overflow-y-auto py-0.5 px-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
